import React, { Suspense, lazy } from 'react';
import { HeroSection } from '../components/HeroSection';
import { LazyMount } from '../components/LazyMount';
const TrustBar = lazy(() => import('../components/TrustBar').then(m => ({
  default: m.TrustBar
})));
const ContrastSection = lazy(() => import('../components/ContrastSection').then(m => ({
  default: m.ContrastSection
})));
const ForWhomSection = lazy(() => import('../components/ForWhomSection').then(m => ({
  default: m.ForWhomSection
})));
const BenefitsSection = lazy(() => import('../components/BenefitsSection').then(m => ({
  default: m.BenefitsSection
})));
const ContentPreview = lazy(() => import('../components/ContentPreview').then(m => ({
  default: m.ContentPreview
})));
const BonusSection = lazy(() => import('../components/BonusSection').then(m => ({
  default: m.BonusSection
})));
const PricingSection = lazy(() => import('../components/PricingSection').then(m => ({
  default: m.PricingSection
})));
const GuaranteeSection = lazy(() => import('../components/GuaranteeSection').then(m => ({
  default: m.GuaranteeSection
})));
const TestimonialsSection = lazy(() => import('../components/TestimonialsSection').then(m => ({
  default: m.TestimonialsSection
})));
const ExpertSection = lazy(() => import('../components/ExpertSection').then(m => ({
  default: m.ExpertSection
})));
const FAQSection = lazy(() => import('../components/FAQSection').then(m => ({
  default: m.FAQSection
})));
const Footer = lazy(() => import('../components/Footer').then(m => ({
  default: m.Footer
})));
const SocialProofPopup = lazy(() => import('../components/SocialProofPopup').then(m => ({
  default: m.SocialProofPopup
})));
const StickyCTA = lazy(() => import('../components/StickyCTA').then(m => ({
  default: m.StickyCTA
})));
export function LandingPage() {
  return <main className="w-full min-h-screen bg-bg-main font-inter selection:bg-primary/30" data-id="element-362">
      {/* Above the fold — eager */}
      <HeroSection data-id="element-363" />

      {/* Just-below-the-fold — load right after hero, no IntersectionObserver needed */}
      <Suspense fallback={null} data-id="element-364">
        <TrustBar data-id="element-365" />
        <ContrastSection data-id="element-366" />
      </Suspense>

      {/* Mid-page — mount as user scrolls near each section */}
      <Suspense fallback={null} data-id="element-367">
        <LazyMount minHeight={600} data-id="element-368">
          <ForWhomSection data-id="element-369" />
        </LazyMount>
        <LazyMount minHeight={600} data-id="element-370">
          <BenefitsSection data-id="element-371" />
        </LazyMount>
        <LazyMount minHeight={800} data-id="element-372">
          <ContentPreview data-id="element-373" />
        </LazyMount>
        <LazyMount minHeight={700} data-id="element-374">
          <BonusSection data-id="element-375" />
        </LazyMount>
        <LazyMount id="pricing" minHeight={700} data-id="element-376">
          <PricingSection data-id="element-377" />
        </LazyMount>
      </Suspense>

      {/* Bottom of page — only mount when nearly visible */}
      <Suspense fallback={null} data-id="element-378">
        <LazyMount minHeight={500} data-id="element-379">
          <GuaranteeSection data-id="element-380" />
        </LazyMount>
        <LazyMount minHeight={500} data-id="element-381">
          <TestimonialsSection data-id="element-382" />
        </LazyMount>
        <LazyMount minHeight={500} data-id="element-383">
          <ExpertSection data-id="element-384" />
        </LazyMount>
        <LazyMount minHeight={400} data-id="element-385">
          <FAQSection data-id="element-386" />
        </LazyMount>
        <LazyMount minHeight={200} data-id="element-387">
          <Footer data-id="element-388" />
        </LazyMount>
      </Suspense>

      {/* Floating elements — load on idle */}
      <Suspense fallback={null} data-id="element-389">
        <SocialProofPopup data-id="element-390" />
        <StickyCTA data-id="element-391" />
      </Suspense>
    </main>;
}